import React from 'react';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { FilePickerActiveCaseList } from './file-picker-active-case-list';
import {
  StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument,
  StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument
} from '../../../../../../generated';
import { useQuery } from '@apollo/client';
import { Empty } from 'antd';

interface FilePickerActiveCaseListContainerProps {
  setCaseInfo: (selectedCaseId: string, selectedCaseType: string) => void;
  applicantName: string;
  applicantId: string;
  selectedTab: string
}

export const FilePickerActiveCaseListContainer: React.FC<FilePickerActiveCaseListContainerProps> = (props) => {
  const {
    data: identityVerificationCasesV1Data,
    loading: identityVerificationCasesV1Loading,
    error: identityVerificationCasesV1Error
  } = useQuery(StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument, {
    variables: { applicantId: props.applicantId },
    skip: !props.applicantId
  });

  const {
    data: credentialVerificationCasesV1Data,
    loading: credentialVerificationCasesV1Loading,
    error: credentialVerificationCasesV1Error
  } = useQuery(StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument, {
    variables: { applicantId: props.applicantId },
    skip: !props.applicantId
  });

  // Combine and format data
  const formattedData = [
    ...(identityVerificationCasesV1Data?.identityVerificationCasesV1ByApplicant?.map((item) => ({
      id: item?.id,
      caseType: item?.caseType,
      state: item?.state,
      caseName: item?.caseName,
      createdAt: item?.lastActivityAt
    })) || []),
    ...(credentialVerificationCasesV1Data?.credentialVerificationCasesV1ByApplicant?.map((item) => ({
      id: item?.id,
      caseType: item?.caseType,
      state: item?.state,
      caseName: item?.caseName,
      createdAt: item?.lastActivityAt
    })) || [])
  ];

  return (
    <ComponentQueryLoader
      loading={identityVerificationCasesV1Loading || credentialVerificationCasesV1Loading}
      error={identityVerificationCasesV1Error || credentialVerificationCasesV1Error}
      hasData={formattedData.length > 0}
      hasDataComponent={<FilePickerActiveCaseList selectedTab={props.selectedTab} cases={formattedData} setCaseInfo={props.setCaseInfo} applicantName={props.applicantName} />}
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
